import React from 'react';
import { Box } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';
import { useIntl, type MessageDescriptor } from '@atlassian/jira-intl';
import type { Warning } from '@atlassian/jira-portfolio-3-portfolio/src/common/warning-details/types.tsx';

export type Props = {
	warning: Warning;
	action: (warning: Warning) => void;
	setIsOpen: (isOpen: boolean) => void;
	message: MessageDescriptor;
};

export const WarningAction = ({ warning, action, setIsOpen, message }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Box paddingBlockStart="space.100">
			<Button
				onClick={() => {
					action(warning);
					setIsOpen(false);
				}}
				appearance="primary"
			>
				{formatMessage(message)}
			</Button>
		</Box>
	);
};
